import { DoubleShift } from "../../types/Shift";

export type StoppagesDeepLink = {
  stoppageId: number | null;
  machine: string | null;
  date: string | null;
  shift: DoubleShift | null;
};

export const STOPPAGES_DEEP_LINK_PARAMS = ["stoppageId", "machine", "date", "shift"];

export const STOPPAGES_PATH = "/stoppages";

/**
 * Writes what `readStoppagesDeepLink` reads. Both live here so the param names have one owner and
 * a rename cannot leave a link pointing at something the page no longer looks for.
 */
export const stoppagesLink = (link: Partial<StoppagesDeepLink>): string => {
  const params = new URLSearchParams();

  if (link.stoppageId) params.set("stoppageId", String(link.stoppageId));
  if (link.machine) params.set("machine", link.machine);
  if (link.date) params.set("date", link.date);
  if (link.shift) params.set("shift", link.shift);

  return params.size === 0 ? STOPPAGES_PATH : `${STOPPAGES_PATH}?${params}`;
};

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

const positiveInt = (raw: string | null): number | null => {
  const value = Number(raw);
  return raw && Number.isInteger(value) && value > 0 ? value : null;
};

export const readStoppagesDeepLink = (params: URLSearchParams): StoppagesDeepLink => {
  const shift = params.get("shift");
  const date = params.get("date");

  return {
    stoppageId: positiveInt(params.get("stoppageId")),
    machine: params.get("machine") || null,
    date: date && ISO_DATE.test(date) ? date : null,
    shift: shift === "DAY" || shift === "NIGHT" ? shift : null,
  };
};

export const hasStoppagesDeepLink = (link: StoppagesDeepLink): boolean =>
  link.stoppageId !== null || link.machine !== null || link.date !== null || link.shift !== null;
